import React from 'react';
import { CalculatorProvider } from './context/CalculatorContext';
import CalculatorContent from './components/CalculatorContent';

const SampleSizeCalculator: React.FC = () => {
  return (
    <CalculatorProvider>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
        <CalculatorContent />
      </div>
    </CalculatorProvider>
  );
};

export default SampleSizeCalculator;
